
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/online/exhibitor/info",
      function () {
        return require("private-next-pages/online/exhibitor/info/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/online/exhibitor/info"])
      });
    }
  